import Button, { ButtonProps } from '~components/Button';

import { cssDefaultInline } from './style';

export default function ButtonAdmin({ children, inlineCss, ...props }: ButtonProps) {
  return (
    <Button variant='light' size='md' inlineCss={[cssDefaultInline, inlineCss]} {...props}>
      {children}
    </Button>
  );
}
